/**
 * Prepares VoxPont interpreter routes for home-screen install:
 * VoxPont manifest, iOS web-app meta, installability service worker,
 * and capture of Chrome's beforeinstallprompt for Settings.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  applyVoxPontInstallDocument,
  captureVoxPontBeforeInstallPrompt,
  clearDeferredVoxPontInstallPrompt,
  registerVoxPontInstallServiceWorker,
  shouldPrepareVoxPontInstall,
} from './voxPontSaveAsApp';

export default function VoxPontSaveAsAppManager() {
  const { pathname } = useLocation();
  const prepare = shouldPrepareVoxPontInstall(pathname);

  useEffect(() => {
    if (!prepare) return undefined;
    return applyVoxPontInstallDocument(pathname || '/voxpont12');
  }, [prepare, pathname]);

  useEffect(() => {
    if (!prepare) return undefined;
    void registerVoxPontInstallServiceWorker();
    const onPrompt = (event) => {
      captureVoxPontBeforeInstallPrompt(event);
    };
    const onInstalled = () => {
      clearDeferredVoxPontInstallPrompt();
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, [prepare]);

  return null;
}
